module.exports = __webpack_public_path__ + "static/media/omni-bridgeway-logo.e11082b5.png";